import { FC } from 'react'
import { ZoningIcon } from 'src/components/insights/icons/zoning'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'
import ParcelZoningDetails from 'src/v2/views/owner-reveal/insights/parcel-insights/zoning/zoning-details'
import ParcelZoningCodes from 'src/v2/views/owner-reveal/insights/parcel-insights/zoning/zoning-codes'
import ParcelZoningUses from 'src/v2/views/owner-reveal/insights/parcel-insights/zoning/zoning-uses'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'
import { Colors } from 'src/components/theme'

const ParcelZoningComponent: FC<InsightComponentProps> = ({ insight }) => {
  return (
    <InsightContainer insight={insight} color={Colors.primaryGreen700} iconBgColor={Colors.primaryGreen50}>
      <ParcelZoningDetails />
      <ParcelZoningCodes />
      <ParcelZoningUses type="conditional_uses" />
      <ParcelZoningUses type="as_of_right" />
      <ParcelZoningUses type="prohibited" />
    </InsightContainer>
  )
}

export const ParcelZoning: Insight = {
  id: 'parcel-zoning',
  tabId: COMMANDAI_IDS_MAP.ownerReveal['parcel-zoning-tab'],
  component: ParcelZoningComponent,
  name: 'Zoning',
  icon: ZoningIcon,
  linkTooltipFile: 'zoning',
  supportedResultTypes: ['parcel'],
}
